<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding-bottom:0px;"
      v-if="bankformList.billState === 2 "
    >
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="来源：">{{ formTypes(bankformList.fromType) }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态：" :style="{color:bankformList.billState === 4 ? '#D35E5E' : ''}">{{ billStates(bankformList.billState)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="票据金额：">{{bankformList.billMoney}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="承兑票号：">{{bankformList.billNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{bankformList.billCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票行：">{{bankformList.billBank}}</el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="出票日期：">{{bankformList.billDate | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期：">{{(bankformList.billEnddate) | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8" v-if="bankformList.billAttachment">
            <el-form-item label="承兑凭证：">
              <span class="down" style="margin-left: 0px;">
                <el-button type="text" @click="previewFile(bankformList.billAttachment)">查看</el-button>
                <el-button type="text" @click="downloadFile(bankformList.billAttachment)">下载</el-button>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="24">
          <el-col :span="8" style="margin-top:-1px">
            <el-form-item label="期限：">{{bankformList.billDays}}天</el-form-item>
          </el-col>
          <el-col :span="8" style="margin-top:-1px" v-if="bankformList.billState === 1">
            <el-form-item label="到期天数：">{{bankformList.day}}天</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用对象：">
              <span class="look" v-cust @click="goCustomerDetail(bankformList)">{{bankformList.cbName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="添加人：">{{bankformList.createUser | isNoData}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="添加时间：">{{bankformList.createDate | dateFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="备注：">{{bankformList.mark | isNoData}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 已作废-------------------------------------------------------------------------------------------------- -->
    <div
      class="item-box-content"
      style="padding-bottom:0px;"
      v-else
    >
      <!-- v-if="this.$route.query.billState ===4 ||this.$route.query.billState === 3 || this.$route.query.billState === 1 " -->
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="来源：">{{formTypes( bankformList.fromType) }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态：" :style="{color:bankformList.billState === 4 ? '#D35E5E' : ''}">{{ billStates(bankformList.billState)}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="票据金额：">{{bankformList.billMoney | billMoney}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="承兑票号：">{{bankformList.billNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{bankformList.billCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票行：">{{bankformList.billBank}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="出票日期：">{{bankformList.billDate  | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期：">{{(bankformList.billEnddate) | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8" v-if="bankformList.billAttachment" >
            <el-form-item label="承兑凭证：">
              <span class="down">
                <el-button type="text" @click="previewFile(bankformList.billAttachment)" style="margin-left:-20px">查看</el-button>
                <el-button type="text" @click="downloadFile(bankformList.billAttachment)">下载</el-button>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8" style="margin-top:-5px">
            <el-form-item label="期限：">{{bankformList.billDays}}天</el-form-item>
          </el-col>
          <el-col :span="8" style="margin-top:-5px" v-if="bankformList.billState === 1">
            <el-form-item label="到期天数：">还剩{{bankformList.day}}天</el-form-item>
          </el-col>
          <el-col :span="8"></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="添加人：">{{bankformList.createUser | isNoData}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="添加时间：">{{bankformList.createDate | dateFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：">{{bankformList.mark | isNoData}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 已使用-------------------------------------------------------------------------------------- -->
<!--    <div-->
<!--      class="item-box-content"-->
<!--      style="padding-bottom:0px;"-->
<!--      v-if="this.$route.query.billState === 2"-->
<!--    >-->
<!--      <div class="title-font-style">-->
<!--        <span>基本信息</span>-->
<!--      </div>-->
<!--      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">-->
<!--        <el-row :gutter="24">-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="来源：">{{ formTypes(bankformList.fromType) }}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="状态：">-->
<!--              <span style="color:red">{{ billStates(bankformList.billState)}}</span>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="票据金额：">{{bankformList.billMoney | billMoney}}</el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="24">-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="承兑票号：">{{bankformList.billNumber}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="出票单位：">{{bankformList.billCompany}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="出票行：">{{bankformList.billBank}}</el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->

<!--        <el-row :gutter="24">-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="出票日期：">{{bankformList.billDate | dateFilterD}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="到期日期：">{{(bankformList.billEnddate) | dateFilterD}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8"  v-if="bankformList.billAttachment" >-->
<!--            <el-form-item label="承兑凭证：">-->
<!--              <span class="down">-->
<!--                <el-button type="text" @click="previewFile(bankformList.billAttachment)">查看</el-button>-->
<!--                <el-button type="text" @click="downloadFile(bankformList.billAttachment)">下载</el-button>-->
<!--              </span>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->

<!--        <el-col style="margin-top:-5px">-->
<!--          <el-form-item label="期限：">{{bankformList.billDays}}天</el-form-item>-->
<!--        </el-col>-->
<!--        <el-col :span="8" style="margin-top:-5px">-->
<!--          <el-form-item label="到期天数：">{{bankformList.day}}天</el-form-item>-->
<!--        </el-col>-->
<!--        <el-col :span="8">-->
<!--          <el-form-item label="使用对象：">{{bankformList.cbName}}</el-form-item>-->
<!--        </el-col>-->

<!--        <el-row :gutter="24">-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="添加人：">{{bankformList.createUser}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="添加时间：">{{bankformList.createDate | dateFilterD}}</el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <el-form-item label="备注：">{{bankformList.mark}}</el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-form>-->
<!--    </div>-->
    <!-- 已提现-----------------------------------------------------------------------------------信息 -->
    <div
      class="item-box-content"
      style="padding-bottom:0px;"
      v-if="this.$route.query.billState === 3 || this.$route.query.billState === '3'"
    >
      <div class="title-font-style">
        <span>贴现信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="贴现银行：">{{ bankformList.billDiscountBank }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="贴现日期：">{{ formatData(bankformList.billDiscountDate)}}</el-form-item>
          </el-col>
          <el-col :span="8"></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="票据金额：">{{bankformList.billMoney | billMoney}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际到账金额：">{{bankformList.billDiscountMoneyReal | billDiscountMoneyReal}}</el-form-item>
          </el-col>
          <el-col :span="8"></el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="贴现备注：">{{bankformList.billDiscountMark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-------------- 工单日志 -------------->
    <load-operation-log :title="titleLog" :id="bankformList.id" v-if="bankformList.id"></load-operation-log>
    <brand-dialog ref='brandDialogRef' :title="`查看`"></brand-dialog>
  </div>
</template>
<script>
import noticeApi from '@/api/workbench/notice'
import { downLoadFile, isSuccess } from '@/util/tool'
import { queryAcceptanceBillByFabId } from '@/api/fiance/fianceManage'
import loadOperationLog from '@/components/OperationLog/loadOperationLog' // 工单日志
import { formatData } from '@/util/filterCommon'
import checkApi from '@/api/workbench/check'
import brandDialog from '@/views/crm/components/supplier/dialog/brandDialog'

export default {
  components: {
    'load-operation-log': loadOperationLog,
    brandDialog
  },
  data () {
    return {
      isShow: false,
      titleLog: '工单日志',
      id: this.$route.query.fprsId,
      type: 2,
      bankformList: {
        fromType: ''
      },
      params: {},
      billState: this.$route.query.billState
    }
  },
  filters: {
    billMoney (billMoney) {
      if (!billMoney) {
        return ''
      }
      return billMoney.toFixed(2)
    },
    billDiscountMoneyReal (billDiscountMoneyReal) {
      if (!billDiscountMoneyReal) {
        return ''
      }
      return billDiscountMoneyReal.toFixed(2)
    }
  },
  async mounted () {
    await queryAcceptanceBillByFabId(this.$route.query.fprsId, this.$route.query.type)
      .then((res) => {
        if (res.data.code === 200) {
          this.bankformList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    goCustomerDetail (row) {
      if (!row.cbName) return
      // this.$router.push({ name: 'customer/details', query: { id: id } })
      this.$router.push({ name: 'supplierEdit', query: { id: row.cbId } })
    },
    formatData,
    // 获取公告详情
    queryNoticeDetail (snIdex) {
      let { snId } = this
      if (snIdex) {
        snId = snIdex
      }
      noticeApi
        .queryNoticeDetail({
          snId
        })
        .then((res) => {
          if (isSuccess(res)) {
            this.noticeDetailsObj = res.data.obj
            this.lastSnId = res.data.obj.lastSnId
            this.nextSnId = res.data.obj.nextSnId
          } else {
            this.$message({
              message: res.data.msg
            })
          }
        })
    },
    formTypes (fromType) {
      // 1后台添加  2业务来源
      switch (fromType) {
        case 1:
          return '后台添加'
          break
        case 2:
          return '收款申请'
          break
      }
    },
    billStates (billState) {
      if (billState === 1) {
        return '未使用'
      } else if (billState === 2) {
        return '已使用'
      } else if (billState === 3) {
        return '已贴现'
      } else if (billState === 4) {
        return '已作废'
      }
    },
    // 查看文件
    previewFile (guid) {
      checkApi.getPactFileUrl({ guid }).then(res => {
        if (isSuccess(res)) {
          const { filePath } = res.data.obj
          if (filePath) {
            const file = filePath.split('.')
            const fileType = file[file.length - 1]
            this.$refs.brandDialogRef.onBlackDialog([{
              filePath,
              fileExt: '.' + fileType
            }])
          }
        }
      })
    },
    // 下载文件
    downloadFile (guid) {
      noticeApi
        .downloadNoticeFile({
          guid
        })
        .then((res) => {
          downLoadFile(res)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .pay {
    padding-top: 8px;
    font-weight: bold;
  }

  .look {
    color: #276CFF;
    padding-left: 10px;
  }

  .down {
    margin-left: 25px;
    margin-top: -10px;
  }
</style>
